function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useMemo, useState } from 'react';
import { Button, Card, Form, Input, Space, Table, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { fetchAdminRankRequestPendingList } from '../../cores/api/api-dashboard';
const Text = Typography.Text;
export default function RankRequestPendingPage() {
    var _a, _b, _c, _d, _e, _f, _g;
    const _Form$useForm = Form.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), form = _Form$useForm2[0];
    const _useState = useState(1), _useState2 = _slicedToArray(_useState, 2), page = _useState2[0], setPage = _useState2[1];
    const _useState3 = useState(20), _useState4 = _slicedToArray(_useState3, 2), limit = _useState4[0], setLimit = _useState4[1];
    const _useState5 = useState(''), _useState6 = _slicedToArray(_useState5, 2), nameFilter = _useState6[0], setNameFilter = _useState6[1];
    const queryParams = useMemo(() => _objectSpread({
        page,
        limit
    }, nameFilter.trim() ? {
        name: nameFilter.trim()
    } : {}), [page, limit, nameFilter]);
    const _useQuery = useQuery({
        queryKey: ['admin-rank-request-pending', queryParams],
        queryFn: () => fetchAdminRankRequestPendingList(queryParams),
        keepPreviousData: true
    }), data = _useQuery.data, isLoading = _useQuery.isLoading, isFetching = _useQuery.isFetching;
    const users = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.users) !== null && _b !== void 0 ? _b : [];
    const pagination = (_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.pagination;
    const columns = [{
            title: 'ユーザーID',
            dataIndex: 'id',
            width: 100,
            render: id => /*#__PURE__*/ React.createElement("a", {
                href: `/userpage?id=${id}`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "text-blue-600 hover:underline text-[12px]"
            }, id)
        }, {
            title: 'Twitter Id',
            dataIndex: 'twitterid',
            width: 160,
            render: (value, record) => value ? /*#__PURE__*/ React.createElement("a", {
                href: `/userpage?id=${record.id}`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "text-blue-600 hover:underline text-[12px]"
            }, "@", value) : '-'
        }, {
            title: 'Twitter名',
            dataIndex: 'twitter_name',
            width: 180,
            render: value => value || '-'
        }, {
            title: 'メール',
            dataIndex: 'email',
            width: 220
        }, {
            title: '現在ランク',
            key: 'current_rank',
            width: 120,
            render: (_, record) => /*#__PURE__*/ React.createElement("span", null, record.current_rank_code, /*#__PURE__*/ React.createElement(Text, {
                type: "secondary",
                className: "text-[11px] block"
            }, record.current_rank_name))
        }, {
            title: '次ランク',
            dataIndex: 'next_rank_code',
            width: 90,
            align: 'center'
        }, {
            title: '申請日',
            key: 'last_request',
            width: 160,
            render: (_, record) => { var _a; return ((_a = record.last_request) === null || _a === void 0 ? void 0 : _a.created_at) ? dayjs(record.last_request.created_at).format('YYYY-MM-DD HH:mm') : '-'; }
        }, {
            title: 'レビュー',
            key: 'review',
            width: 100,
            align: 'center',
            render: (_, record) => `${record.review_score} / ${record.review_count}`
        }, {
            title: '操作',
            key: 'action',
            width: 100,
            render: (_, record) => /*#__PURE__*/ React.createElement("a", {
                href: `/userpage?id=${record.id}`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "text-blue-600 hover:underline text-[12px]"
            }, "\u78BA\u8A8D")
        }];
    const handleSearch = values => {
        var _a;
        setNameFilter(((_a = values.name) === null || _a === void 0 ? void 0 : _a.trim()) || '');
        setPage(1);
    };
    const handleReset = () => {
        form.resetFields();
        setNameFilter('');
        setPage(1);
    };
    const handleTableChange = tablePagination => {
        var _a, _b;
        setPage((_a = tablePagination.current) !== null && _a !== void 0 ? _a : 1);
        setLimit((_b = tablePagination.pageSize) !== null && _b !== void 0 ? _b : 20);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "rank-request-pending-page"
    }, /*#__PURE__*/ React.createElement(Card, {
        className: "mb-4"
    }, /*#__PURE__*/ React.createElement(Text, {
        type: "secondary",
        className: "text-[13px] block mb-3"
    }, "\u30E9\u30F3\u30AF\u7533\u8ACB\u4E2D\u306E\u7537\u6027\u30E6\u30FC\u30B6\u30FC\u3092\u4E00\u89A7\u8868\u793A\u3057\u307E\u3059\u3002\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u5165\u529B\u306F\u4E0D\u8981\u3067\u3059\u3002"), /*#__PURE__*/ React.createElement(Form, {
        form: form,
        layout: "inline",
        onFinish: handleSearch
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u691C\u7D22",
        name: "name"
    }, /*#__PURE__*/ React.createElement(Input, {
        allowClear: true,
        placeholder: "\u30E1\u30FC\u30EB / Twitter ID / Twitter\u540D",
        style: {
            width: 280
        }
    })), /*#__PURE__*/ React.createElement(Form.Item, null, /*#__PURE__*/ React.createElement(Space, null, /*#__PURE__*/ React.createElement(Button, {
        onClick: handleReset
    }, "\u30EA\u30BB\u30C3\u30C8"), /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        htmlType: "submit"
    }, "\u7D5E\u308A\u8FBC\u307F"))))), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement("div", {
        className: "mb-3 text-[13px]"
    }, "\u7533\u8ACB\u4E2D: ", /*#__PURE__*/ React.createElement("strong", null, (_d = pagination === null || pagination === void 0 ? void 0 : pagination.total_count) !== null && _d !== void 0 ? _d : 0), " \u4EF6"), /*#__PURE__*/ React.createElement(Table, {
        rowKey: "id",
        loading: isLoading || isFetching,
        columns: columns,
        dataSource: users,
        scroll: {
            x: 1200
        },
        onChange: handleTableChange,
        pagination: {
            current: (_e = pagination === null || pagination === void 0 ? void 0 : pagination.page) !== null && _e !== void 0 ? _e : page,
            pageSize: (_f = pagination === null || pagination === void 0 ? void 0 : pagination.limit) !== null && _f !== void 0 ? _f : limit,
            total: (_g = pagination === null || pagination === void 0 ? void 0 : pagination.total_count) !== null && _g !== void 0 ? _g : 0,
            showSizeChanger: true
        }
    })));
}
